(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6017,2576,5124,949],{

/***/ 97157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ opensource; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/OpenSource/components/Hero/Hero.tsx






var copy = {
  heading: "Segment started with an open source project.",
  description: "Since then, we\u2019ve open sourced hundreds of our repos. \n We want to continue supporting the community by publishing \n our code and other developers\u2019 awesome open source projects."
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroComponent, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
            variant: "pLarge",
            tag: "p",
            children: copy.description
          })]
        })
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1wuvh7g4"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "e1wuvh7g3"
} : 0)(Hero/* Wrapper */.im, "{padding-bottom:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-left:0;padding-right:0;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:20px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("sm");
}, "{padding-bottom:20px;}}" + ( true ? "" : 0));

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1wuvh7g2"
} : 0)("white-space:pre-line;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("sm");
}, "{max-width:844px;white-space:normal;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.only("xs");
}, "{white-space:pre-line;}" + ( true ? "" : 0));

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1wuvh7g1"
} : 0)(function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.down("md");
}, "{max-width:690px;margin-left:auto;margin-right:auto;text-align:center;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.down("xs");
}, "{padding-top:0;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.only("md");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "e1wuvh7g0"
} : 0)("max-width:844px;", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:-75px;z-index:1;}" + ( true ? "" : 0));

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/index.ts + 12 modules
var Tabs = __webpack_require__(15347);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/useTabs/index.ts + 1 modules
var useTabs = __webpack_require__(53834);
;// CONCATENATED MODULE: ./src/views/OpenSource/components/OurOpenSource/data.ts
var data = [{
  key: "javascript",
  title: "JavaScript/TypeScript",
  cards: [{
    badge: "JavaScript",
    title: "Evergreen",
    description: "React UI framework that implements our Evergreen design system.",
    link: "https://github.com/segmentio/evergreen"
  }, {
    badge: "TypeScript",
    title: "analytics-next",
    description: "The hassle-free way to integrate analytics into any web application.",
    link: "https://github.com/segmentio/analytics-next"
  }, {
    badge: "TypeScript",
    title: "Consent Manager",
    description: "A drop-in consent management plugin for analytics.js.",
    link: "https://github.com/segmentio/consent-manager"
  }, {
    badge: "JavaScript",
    title: "in-eu",
    description: "A privacy-conscious EU detection browser library.",
    link: "https://github.com/segmentio/in-eu"
  }, {
    badge: "JavaScript",
    title: "analytics.js-integrations",
    description: "The monorepo storing most of the analytics.js integrations supported by Segment.",
    link: "https://github.com/segmentio/analytics.js-integrations"
  }, {
    badge: "TypeScript",
    title: "ts-mysql-plugin",
    description: "A TypeScript language service plugin that gives superpowers to SQL tagged template literals.",
    link: "https://github.com/segmentio/ts-mysql-plugin"
  }]
}, {
  key: "go",
  title: "Go",
  cards: [{
    badge: "Go",
    title: "ksuid",
    description: "K-sortable globally unique IDs.",
    link: "https://github.com/segmentio/ksuid"
  }, {
    badge: "Go",
    title: "encoding",
    description: "Encoders and decoders for various data formats, including JSON and ISO 8601.",
    link: "https://github.com/segmentio/encoding"
  }, {
    badge: "Go",
    title: "asm",
    description: "Algorithms implemented in assembly to unlock the full power of modern CPUs.",
    link: "https://github.com/segmentio/asm"
  }, {
    badge: "Go",
    title: "golines",
    description: "A Go formatter that shortens long lines.",
    link: "https://github.com/segmentio/golines"
  }, {
    badge: "Go",
    title: "stats",
    description: "A Go package for abstracting stats collection.",
    link: "https://github.com/segmentio/stats"
  }, {
    badge: "Go",
    title: "conf",
    description: "A Go package for loading program configuration from multiple sources.",
    link: "https://github.com/segmentio/conf"
  }]
}, {
  key: "messaging",
  title: "Messaging",
  cards: [{
    badge: "Go",
    title: "kafka-go",
    description: "Easy-to-use APIs for interacting with Kafka.",
    link: "https://github.com/segmentio/kafka-go"
  }, {
    badge: "Go",
    title: "nsq-go",
    description: "Tools for building NSQ clients, servers and middleware. ",
    link: "https://github.com/segmentio/nsq-go"
  }, {
    badge: "Go",
    title: "topicctl",
    description: "A tool for easy, declarative management of Kafka topics.",
    link: "https://github.com/segmentio/topicctl"
  }]
}, {
  key: "microservices",
  title: "Microservices",
  cards: [{
    badge: "Go",
    title: "Chamber",
    description: "A tool for managing secrets.",
    link: "https://github.com/segmentio/chamber"
  }, {
    badge: "Go",
    title: "ctlstore",
    description: "A distributed data store with very low latency, always-available, and \"infinitely\" scalable reads.",
    link: "https://github.com/segmentio/ctlstore"
  }, {
    badge: "Go",
    title: "kubectl-curl",
    description: "A kubectl plugin to run curl commands against Kubernetes pods.",
    link: "https://github.com/segmentio/kubectl-curl"
  }]
}];
/* harmony default export */ var OurOpenSource_data = (data);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/OpenSource/components/OurOpenSource/OurOpenSource.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var OurOpenSource_copy = {
  heading: "Open source \n projects we use",
  description: "We use these open source projects as the foundations of our infrastructure to handle billions of API calls per day and to allow us to rapidly build and test code on the client."
};
var OurOpenSource_button = {
  url: "https://github.com/segmentio",
  text: "View all projects"
};
var OurOpenSource = function OurOpenSource() {
  var _useTabs = (0,useTabs/* default */.Z)(0, OurOpenSource_data.length, "open-source"),
      getTrackProps = _useTabs.getTrackProps,
      getControlProps = _useTabs.getControlProps,
      getPanelProps = _useTabs.getPanelProps,
      activeTabKey = _useTabs.activeTabKey;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopyHead, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OurOpenSource_StyledCopyTextHeading, {
          tag: "h3",
          variant: "h2",
          children: OurOpenSource_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextDescription, {
          tag: "p",
          children: OurOpenSource_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionComponent, {
        variant: "centered",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
            centered: true,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* default */.ZP, {
              variant: "filled",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* Track */.fQ, _objectSpread(_objectSpread({}, getTrackProps()), {}, {
                children: OurOpenSource_data.map(function (tab, index) {
                  return (0,emotion_react_browser_esm/* createElement */.az)(Tabs/* Control */.oT, _objectSpread(_objectSpread({}, getControlProps(index)), {}, {
                    key: tab.key
                  }), tab.title);
                })
              }))
            })
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide, _objectSpread(_objectSpread({}, getPanelProps(activeTabKey)), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
              columns: 1,
              overrides: {
                md: 2,
                lg: 3
              },
              center: true,
              children: OurOpenSource_data[activeTabKey].cards.map(function (card) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardBase, {
                  href: card.link,
                  layout: "vertical",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                          variant: "outlined",
                          children: card.badge
                        })
                      })
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                        children: card.title
                      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                        children: card.description
                      })]
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                      alignment: "right",
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                    })]
                  })
                }, card.title);
              })
            })
          }))
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
      centered: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Link */.rU, {
        href: OurOpenSource_button.url,
        children: [" ", OurOpenSource_button.text, " "]
      })
    })]
  });
};

var OurOpenSource_StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "eflmprw9"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("xs");
}, "{text-align:center;white-space:pre-line;}" + ( true ? "" : 0));

var CopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "eflmprw8"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var SectionCopyHead = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "eflmprw7"
} : 0)( true ? {
  name: "1bp09d0",
  styles: "padding-bottom:40px"
} : 0);

var StyledCardBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Body */.uT,  true ? {
  target: "eflmprw6"
} : 0)("margin-top:-10px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.pSmall.css;
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eflmprw5"
} : 0)(Section/* Wrapper */.im, "{max-height:100%;row-gap:0;}" + ( true ? "" : 0));

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eflmprw4"
} : 0)("max-width:1280px;padding-bottom:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:20px;margin-bottom:-60px;}overflow-x:visible;", Section/* Wrapper */.im, "{padding:0;}" + ( true ? "" : 0));

var Slide = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Panel */.s_,  true ? {
  target: "eflmprw3"
} : 0)("max-width:100%;flex-shrink:1;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.only("md");
}, "{max-width:736px;align-self:center;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:48px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{column-gap:120px;row-gap:0;}" + ( true ? "" : 0));

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "eflmprw2"
} : 0)("max-width:352px;height:100%;min-width:0;overflow-wrap:break-word;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.only("sm");
}, "{max-width:100%;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.only("xs");
}, "{max-width:100%;}:hover{", StyledCardBody, "{color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.neutrals.white[100];
}, ";}}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "eflmprw1"
} : 0)("max-width:1120px;align-items:stretch;justify-items:stretch;padding-left:0;padding-right:0;margin:0 auto;", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.down("md");
}, "{max-width:100%;}" + ( true ? "" : 0));

var TabsLayout = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eflmprw0"
} : 0)("display:flex;flex-wrap:wrap;flex-direction:column;justify-content:center;align-content:center;align-items:center;width:100%;padding-top:20px;padding-bottom:56px;", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.only("md");
}, "{align-items:center;}", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.down("md");
}, "{flex-wrap:nowrap;align-items:stretch;}" + ( true ? "" : 0));

/* harmony default export */ var OurOpenSource_OurOpenSource = (OurOpenSource);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/OpenSource/components/MoreResources/MoreResources.tsx


function MoreResources_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var cards = [{
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* PerformanceMonitoringIcon */.RY, {}),
  title: "Segment  Engineering",
  body: "Segment is the single platform to collect and manage analytics data.",
  link: "/engineering/"
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* HostIcon */.fV, {}),
  title: "Engineering Blog",
  body: "A showcase of solutions and best practices from Segment engineers.",
  link: "/blog/category/engineers-and-developers/"
}];
var MoreResources_copy = {
  heading: "More resources",
  description: "We use these open source projects as the foundations of our infrastructure to handle billions of API calls per day."
};
var MoreResources = function MoreResources() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreResources_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreResources_StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            children: MoreResources_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreResources_CopyTextDescription, {
            tag: "p",
            variant: "pLarge",
            children: MoreResources_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreResources_StyledColumnTrack, {
          columns: 1,
          overrides: {
            md: 2
          },
          children: cards.map(function (card, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              layout: "vertical",
              href: (0,getAbsoluteUrl/* default */.Z)(card.link, pageConfig),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                    children: card.icon
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    variant: "h4",
                    tag: "h4",
                    children: card.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    variant: "pLarge",
                    children: card.body
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, index);
          })
        })
      })]
    })
  });
};

var MoreResources_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehi7xlp5"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "ehi7xlp4"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

var MoreResources_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "ehi7xlp3"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{max-width:736px;}" + ( true ? "" : 0));

var MoreResources_CopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "ehi7xlp2"
} : 0)( true ? {
  name: "hu8msh",
  styles: "max-width:532px;height:64px;text-align:center"
} : 0);

var MoreResources_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ehi7xlp1"
} : 0)("max-width:1280px;padding-bottom:120px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:0px;}", Section/* Wrapper */.im, "{padding-bottom:0;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:0;}}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ehi7xlp0"
} : 0)("max-width:844px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var MoreResources_MoreResources = (MoreResources);
;// CONCATENATED MODULE: ./src/views/OpenSource/components/Cards/Cards.tsx


function Cards_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var StyledSectionContentCenter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1r9m4gw3"
} : 0)( true ? {
  name: "12one6h",
  styles: "display:flex;justify-content:center;align-content:center;padding-top:0"
} : 0);

var Cards_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1r9m4gw2"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.only("md");
}, "{max-width:736px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{justify-items:stretch;}" + ( true ? "" : 0));

var Cards_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1r9m4gw1"
} : 0)("max-width:1280px;padding-top:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.only("md");
}, "{padding-top:0;margin-top:0;}", Section/* Wrapper */.im, "{padding-bottom:80px;}" + ( true ? "" : 0));

var Cards_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1r9m4gw0"
} : 0)("background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var Cards_cards = [{
  badge: "TypeScript",
  title: "analytics-next",
  description: "The hassle-free way to integrate analytics into any web application.",
  link: "https://github.com/segmentio/analytics-next"
}, {
  badge: "JavaScript",
  title: "Evergreen",
  description: "React UI framework that implements our Evergreen design system.",
  link: "https://github.com/segmentio/evergreen"
}, {
  badge: "Go",
  title: "kafka-go",
  description: "Easy-to-use APIs for interacting with Kafka.",
  link: "https://github.com/segmentio/kafka-go"
}];
var Cards = function Cards() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContentCenter, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_StyledColumnTrack, {
          center: true,
          columns: 1,
          overrides: {
            md: 2,
            lg: 3
          },
          gap: "medium",
          children: Cards_cards.map(function (card) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              href: card.link,
              layout: "vertical",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                      variant: "outlined",
                      children: card.badge
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    tag: "h2",
                    children: card.title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    tag: "p",
                    children: card.description
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, card.title);
          })
        })
      })
    })
  });
};
/* harmony default export */ var Cards_Cards = (Cards);
// EXTERNAL MODULE: ./src/views/OpenSource/assets/OgOpenSource.png
var OgOpenSource = __webpack_require__(6427);
var OgOpenSource_default = /*#__PURE__*/__webpack_require__.n(OgOpenSource);
;// CONCATENATED MODULE: ./src/views/OpenSource/OpenSource.tsx














var OpensourceView = function OpensourceView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Segment Open",
      pageDescription: "Twilio Segment started with an open source project.",
      pageOG: (OgOpenSource_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_Cards, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OurOpenSource_OurOpenSource, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreResources_MoreResources, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "eltpu370"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var OpenSource_OpenSource = (OpensourceView);
;// CONCATENATED MODULE: ./src/pages/opensource.tsx



var OpenSource = function OpenSource() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenSource_OpenSource, {});
};

/* harmony default export */ var opensource = (OpenSource);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 63009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useMaskOnScroll_useMaskOnScroll; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(21687);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/scroll/use-element-scroll.mjs
var use_element_scroll = __webpack_require__(66057);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs + 1 modules
var use_transform = __webpack_require__(29682);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-template.mjs
var use_motion_template = __webpack_require__(85770);
// EXTERNAL MODULE: ../../libs/utils/useResizeObserver/index.ts + 1 modules
var useResizeObserver = __webpack_require__(73889);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/useMaskOnScroll.ts



var _templateObject;




/**
 * A hook to create a mask on scroll
 * @param props.wrapper - A ref to the element to observe
 * @param props.axis - The axis to apply the mask
 * @param props.offset - The offset to apply to the mask
 * @returns A string to use as a mask
 */

var useMaskOnScroll = function useMaskOnScroll(_ref) {
  var wrapper = _ref.wrapper,
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? "horizontal" : _ref$axis,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? "8%" : _ref$offset;
  var clientValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var scrollValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var sizeValue = (0,use_motion_value/* useMotionValue */.c)(0);

  var _useElementScroll = (0,use_element_scroll/* useElementScroll */.B)(wrapper),
      scrollYProgress = _useElementScroll.scrollYProgress,
      scrollXProgress = _useElementScroll.scrollXProgress;

  var isVertical = axis === "vertical";
  var scrollProgress = isVertical ? scrollYProgress : scrollXProgress;
  var values = /^([-.\d]+(?:\.\d+)?)(.*)$/.exec(offset);
  var degs = isVertical ? (0,use_motion_value/* useMotionValue */.c)(180) : (0,use_motion_value/* useMotionValue */.c)(90);
  var unit = (0,use_motion_value/* useMotionValue */.c)(values && values[2]);
  var offsetValue = values ? Number(values[1]) : 0;

  if (isVertical) {
    var _wrapper$current;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.getBoundingClientRect().height));
  } else {
    var _wrapper$current2;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.getBoundingClientRect().width));
  }

  (0,react.useEffect)(function () {
    if (unit.get() === "%") return;

    var handleResize = function handleResize() {
      if (isVertical) {
        var _wrapper$current3;

        sizeValue.set(Number((_wrapper$current3 = wrapper.current) === null || _wrapper$current3 === void 0 ? void 0 : _wrapper$current3.getBoundingClientRect().height));
      } else {
        var _wrapper$current4;

        sizeValue.set(Number((_wrapper$current4 = wrapper.current) === null || _wrapper$current4 === void 0 ? void 0 : _wrapper$current4.getBoundingClientRect().width));
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [isVertical, unit]);
  var maskStartSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
        clientValue = _ref3[0],
        scrollValue = _ref3[1],
        scrollProgressValue = _ref3[2];

    return clientValue === scrollValue ? 0 : Math.min(offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskEndSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref4) {
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 3),
        clientValue = _ref5[0],
        scrollValue = _ref5[1],
        scrollProgressValue = _ref5[2];

    return clientValue === scrollValue ? sizeValue.get() : Math.max(sizeValue.get() - offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskImage = (0,use_motion_template/* useMotionTemplate */.Y)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["linear-gradient(", "deg, rgba(0,0,0,0) 0", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,0) ", "", ")"])), degs, unit, maskStartSize, unit, maskEndSize, unit, sizeValue, unit);
  var setValue = (0,react.useCallback)(function () {
    var _ref6, _wrapper$current5, _wrapper$current6, _ref7, _wrapper$current7, _wrapper$current8;

    clientValue.set((_ref6 = isVertical ? (_wrapper$current5 = wrapper.current) === null || _wrapper$current5 === void 0 ? void 0 : _wrapper$current5.clientHeight : (_wrapper$current6 = wrapper.current) === null || _wrapper$current6 === void 0 ? void 0 : _wrapper$current6.clientWidth) !== null && _ref6 !== void 0 ? _ref6 : 0);
    scrollValue.set((_ref7 = isVertical ? (_wrapper$current7 = wrapper.current) === null || _wrapper$current7 === void 0 ? void 0 : _wrapper$current7.scrollHeight : (_wrapper$current8 = wrapper.current) === null || _wrapper$current8 === void 0 ? void 0 : _wrapper$current8.scrollWidth) !== null && _ref7 !== void 0 ? _ref7 : 0);
  }, [clientValue, wrapper, scrollValue]);
  (0,useResizeObserver/* default */.Z)(wrapper, setValue);
  (0,react.useEffect)(function () {
    return setValue();
  }, [setValue]);
  return maskImage;
};

/* harmony default export */ var useMaskOnScroll_useMaskOnScroll = (useMaskOnScroll);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/index.ts


/***/ }),

/***/ 73889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useResizeObserver_useResizeObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(97209);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/useResizeObserver.ts


/**
 * The useResizeObserver reports changes to the dimensions of an element's content or border box
 * @param ref - A ref to the element to observe
 * @param fn - A callback function called when size of the observed element change
 */

var useResizeObserver = function useResizeObserver(ref, fn) {
  (0,react.useEffect)(function () {
    var resizeObserver = new ResizeObserver_es/* default */.Z(function () {
      fn();
    });

    if (ref !== null && ref !== void 0 && ref.current) {
      resizeObserver.observe(ref.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [fn, ref]);
};

/* harmony default export */ var useResizeObserver_useResizeObserver = (useResizeObserver);
;// CONCATENATED MODULE: ../../libs/utils/useResizeObserver/index.ts


/***/ }),

/***/ 32523:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A hook to scroll to an element
 *
 * @param container - A ref to the container to scroll
 * @returns A function to scroll to an element
 */
var useScrollTo = function useScrollTo(container) {
  return function (element) {
    var el = element.current;
    var parent = container.current;

    if (parent && el) {
      parent.scrollTo({
        left: el.offsetLeft - (parent.offsetWidth - el.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollTo);

/***/ }),

/***/ 82201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opensource",
      function () {
        return __webpack_require__(97157);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6427:
/***/ (function(module) {

module.exports = "/_next/static/images/OgOpenSource-ff87994566e3053d0d9dd8539253be3b.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,7209,3486,6234,4136,2073,6784,8392,5735,2429,2609,8187,442,4881,9550,6278,9774,2888,179], function() { return __webpack_exec__(82201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);